
document.addEventListener('DOMContentLoaded', () => {
  //productListScale();
  // detailViewMore();
  stockistViewMore();
  addClassToSquareImages();

});






//商品一覧SCALEの機能(保留)
function productListScale() {
  const toggleElement = document.querySelector('.popout--scale .popout_scale__toggle');
  if (toggleElement) {
    toggleElement.addEventListener('click', function () {
      const productItems = document.querySelectorAll('.product-item');
      const hasClassOneQuarter = Array.from(productItems).some(item => item.classList.contains('large-up--one-quarter'));

      if (hasClassOneQuarter) {
        document.querySelectorAll('.popout--scale').forEach(elem => elem.classList.add('scalex2'));
        document.querySelectorAll('.collection-scale-open').forEach(elem => elem.style.display = 'none');
        document.querySelectorAll('.collection-scale-close').forEach(elem => elem.style.display = 'inline-block');
        productItems.forEach(item => {
          item.classList.remove('large-up--one-quarter');
          item.classList.add('large-up--one-third');
        });
      } else {
        document.querySelectorAll('.popout--scale').forEach(elem => elem.classList.remove('scalex2'));
        document.querySelectorAll('.collection-scale-open').forEach(elem => elem.style.display = 'inline-block');
        document.querySelectorAll('.collection-scale-close').forEach(elem => elem.style.display = 'none');
        productItems.forEach(item => {
          item.classList.add('large-up--one-quarter');
          item.classList.remove('large-up--one-third');
        });
      }
    });
  }
}

//商品詳細商品説明文のVIEW MOREの機能（保留）
// function detailViewMore() {
//   // ページ読み込み時に.tab-content-0の存在をチェック
//   const tabContent0 = document.querySelector('.tab-content-0');
//   if (!tabContent0) return; // .tab-content-0が存在しない場合、処理を終了

//   let baseHeight = 0; // 初期値設定
//   let isButtonClicked = false; // ボタンがクリックされたかどうかを追跡
//   const descriptionWrapperP = document.querySelector('.description-wrapper'); // ('.description-wrapper p');
//   const descriptionWrapper = document.querySelector('.description-wrapper'); // .description-wrapperへの参照を追加

//   // baseHeightを更新し、条件に応じてクラスを追加/削除する関数
//   const updateBaseHeight = () => {
//     baseHeight = descriptionWrapperP.offsetHeight; // .description-wrapper pの高さを取得
//     adjustHeightAndClass();
//   };

//   // 高さとクラスを調整する関数
//   const adjustHeightAndClass = () => {
//     if (baseHeight >= 63) {
//       tabContent0.classList.add('over-height');
//     } else {
//       tabContent0.classList.remove('over-height');
//     }
//     if (isButtonClicked) {
//       descriptionWrapper.style.maxHeight = '1000px';
//       // descriptionWrapper.style.height = '100%';//`${baseHeight}px`; // ボタンクリック後は高さを設定
//       tabContent0.classList.remove('over-height');
//     }
//   }

//   // 初期の高さを設定し、リサイズイベントに対応
//   updateBaseHeight();
//   window.addEventListener('resize', function () {
//     updateBaseHeight(); // リサイズ時も高さを更新
//     if (isButtonClicked) {
//       // ボタンがクリックされた後のリサイズでは、高さを再設定
//       descriptionWrapper.style.height = '100%';//`${baseHeight}px`;
//     }
//   });

//   // buttonクリック時の動作を定義
//   tabContent0.querySelector('button').addEventListener('click', function () {
//     isButtonClicked = true; // ボタンがクリックされたことを記録
//     updateBaseHeight(); // クリック時に.baseHeightを更新し、適切に高さを設定
//   });
// }

function addClassToSquareImages() {
  // '.grid-outer .product-item__image .image-wrapper img' と '.product__wrapper .product__images .product__photo img' のすべての要素を選択
  var gridImages = document.querySelectorAll('.grid-outer .product-item__image .image-wrapper img');
  var productImages = document.querySelectorAll('.product__wrapper .product__images .product__photo img');

  // 画像に対して処理を適用する関数
  function processImages(images) {
    // 画像が1つでも存在するかチェック
    if (images.length > 0) {
      // 各画像に対してループ処理
      images.forEach(function (img) {
        // 画像が読み込まれた後にサイズをチェック
        img.onload = function () {
          // 画像の高さと幅が同じ場合（正方形の場合）
          if (img.naturalHeight === img.naturalWidth) {
            // 'is-square'クラスを追加
            img.classList.add('is-square');
          }
        };

        // 画像がキャッシュから読み込まれた場合は、onloadイベントが発火しない可能性があるため、
        // 画像がすでに読み込まれているかどうかをチェックし、条件を満たしていればクラスを追加
        if (img.complete && img.naturalHeight === img.naturalWidth) {
          img.classList.add('is-square');
        }
      });
    }
  }

  // 両方のセレクターに対して処理を適用
  processImages(gridImages);
  processImages(productImages);
}







function stockistViewMore() {
  // ページ読み込み時に.tab-content-3の存在をチェック
  const tabContent3 = document.querySelector('.tab-content-3');
  if (!tabContent3) return; // .tab-content-3が存在しない場合、処理を終了

  let baseHeight = 0; // 初期値設定
  const descriptionWrapperP = document.querySelector('.tab-content-3 .stockistWrapper');
  const descriptionWrapper = document.querySelector('.tab-content-3 .stockistWrapper');

  // baseHeightを更新し、条件に応じてクラスを追加/削除する関数
  const updateBaseHeight = () => {
    baseHeight = descriptionWrapperP.offsetHeight; // .description-wrapper pの高さを取得
    adjustHeightAndClass();
  };

  // 高さとクラスを調整する関数
  const adjustHeightAndClass = () => {
    if (baseHeight >= 106) {
      tabContent3.classList.add('over-height');
    } else {
      tabContent3.classList.remove('over-height');
    }
    if (tabContent3.querySelector('button').classList.contains('isOpen')) {
      descriptionWrapper.style.maxHeight = '3000px';
    } else {
      descriptionWrapper.style.maxHeight = '117px';
    }
  }

  // 初期の高さを設定し、リサイズイベントに対応
  updateBaseHeight();
  window.addEventListener('resize', function () {
    updateBaseHeight(); // リサイズ時も高さを更新
    if (tabContent3.querySelector('button').classList.contains('isOpen')) {
      // ボタンがクリックされた後のリサイズでは、高さを再設定
      descriptionWrapper.style.height = '100%';//`${baseHeight}px`;
    }
  });

  // buttonクリック時の動作を定義
  tabContent3.querySelector('button').addEventListener('click', function () {
    if(this.classList.contains('isOpen')) {
      // 閉じる時の処理
      this.classList.remove('isOpen')
      this.textContent = "READ MORE"
    } else {
      // 開く時の処理
      this.classList.add('isOpen')
      this.textContent = "CLOSE"
    }
    updateBaseHeight(); // クリック時に.baseHeightを更新し、適切に高さを設定
  });
}